module.exports = __webpack_public_path__ + "static/img/pro_icon.a9b8691.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/pro_icon.png
// module id = DpIo
// module chunks = 37